var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.935 2.056A6.963 6.963 0 006.991 0 6.99 6.99 0 000 7c0 3.867 3.124 7 6.991 7 3.264 0 5.985-2.231 6.764-5.25h-1.82a5.241 5.241 0 01-4.944 3.5A5.254 5.254 0 011.741 7a5.254 5.254 0 015.25-5.25c1.453 0 2.748.604 3.693 1.558L7.866 6.125h6.125V0l-2.056 2.056z"
  })));
}

export default SvgRefresh;